import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import SectionsHeading from "../../SectionsHeading";
import Paragraph from "../../Paragraph";
import CustomButton from "../../CustomBtn";
import image1 from "../../../../../assets/Images/stake.png";
import image2 from "../../../../../assets/Images/trophy.png";
import image3 from "../../../../../assets/Images/give-money.png";
import { GradiantDiv, Image } from "../../../../Styles/style";

const ContinerWraper = styled(Container)`
  height: auto;
  width: 100%;
  padding: 100px 0 !important;
  margin-top: 100px;
  margin-bottom: 100px;
`;

const HowSection = () => {
  return (
    <ContinerWraper maxWidth="xxl">
      <Container>
        <Grid container sx={{ columnGap: "10px" }}>
          <Grid item xs={12} md={5.9} sx={{}}>
            <SectionsHeading
              ta="left"
              fs="46px"
              fs599="46px"
              color="#FC9C00 !important"
            >
              Shia Vault
            </SectionsHeading>
            <Paragraph p="20px 150px 30px 0" p599="20px 0 30px" ta="left" fs="12px">
              Shia Vault empowers users to leverage their Shia tokens as
              collateral, unlocking Ethereum liquidity with a 0% interest model,
              while retaining the potential benefits of their tokens' value.
            </Paragraph>
            <CustomButton
              hbgc="transparent"
              hc="#fff"
              bgc="#fff"
              c="#000"
              b="1px solid #fff"
            >
              Stake
            </CustomButton>
            <CustomButton
              bgc="transparent"
              c="#fff"
              hbgc="#fff"
              hc="#000"
              b="1px solid #fff"
            >
              Borrow
            </CustomButton>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={5.9}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid item xs={12} sm={5.9}>
              <GradiantDiv h="250px">
                <div style={{ display: "flex", alignItems: "center" ,columnGap:"10px"}}>
                  <Image mw="25px" src={image1} />
                  <SectionsHeading
                    ta="left"
                    fs="16px"
                    fs599="16px"
                    color="#FC9C00 !important"
                  >
                    Supply
                  </SectionsHeading>
                </div>
                <Paragraph ta="left" fs="12px" p="10px 0">
                  Unlock the true potential of your Shia tokens by supply your
                  vault in our secure protocol with Shia, actively participating
                  in network integrity while earning rewards.
                </Paragraph>
              </GradiantDiv>
              <GradiantDiv h="250px">
                <div style={{ display: "flex", alignItems: "center" ,columnGap:"10px" }}>
                  <Image mw="25px" src={image2} />
                  <SectionsHeading
                    ta="left"
                    fs="16px"
                    fs599="16px"
                    color="#FC9C00 !important"
                  >
                    Earn
                  </SectionsHeading>
                </div>
                <Paragraph ta="left" fs="12px" p="10px 0">
                  Maximize your Shia holdings by leveraging our platform to
                  borrow, trade, and earn, all within one ecosystem, amplifying
                  your potential for growth.
                </Paragraph>
              </GradiantDiv>
            </Grid>
            <Grid
              item
              xs={12}
              sm={5.9}
              sx={{ display: "flex", height: "auto", alignItems: "center" }}
            >
              <GradiantDiv h="250px">
                <div style={{ display: "flex", alignItems: "center" ,columnGap:"10px" }}>
                  <Image mw="25px" src={image3} />
                  <SectionsHeading
                    ta="left"
                    fs="16px"
                    fs599="16px"
                    color="#FC9C00 !important"
                  >
                    Borrow
                  </SectionsHeading>
                </div>
                <Paragraph ta="left" fs="12px" p="10px 0">
                  Seize opportunities without parting with your Shia tokens.
                  Borrow Ethereum tokens at 0% interest, using your Shia
                  holdings as collateral, and regain them hassle-free.
                </Paragraph>
              </GradiantDiv>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </ContinerWraper>
  );
};

export default HowSection;
